<md-content-box [type]="contentBoxType()">
	<div class="need-help-header">
		<span class="md-text-lg-medium">Need Help?</span>
	</div>

	<div class="need-help-body">
		<p>
			Visit our <a href="https://help.languagebird.com" target="_blank" rel="noopener noreferrer">Help Center</a> for FAQs and support articles, or
			contact your advisor directly for personalized assistance.
		</p>

		<div class="office-hours">
			<p class="md-text-sm-semibold">LanguageBird Office Hours</p>
			<ul>
				<li>Monday to Friday: 6am – 5pm PST</li>
			</ul>
		</div>

		<div class="office-hours">
			<p class="md-text-sm-semibold">Call: <a href="tel:+18447002473">(844) 700-2473 (BIRD)</a></p>
			<ul>
				<li>Academics: Option 1</li>
				<li>IT Support: Option 4</li>
			</ul>
		</div>

		<a [href]="supportTicketUrl()" target="_blank" rel="noopener noreferrer" md-button class="contact-button">Contact Support</a>
	</div>
</md-content-box>
